import React, { useState, useMemo, useEffect } from 'react';
import PartialTable from 'components/partials/PartialTable';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Col, Row } from 'react-bootstrap';
import ImageModal from 'components/common/ImagesModal';
import { getGrnImages } from 'services/stock-location/grnServices';
import { useParams } from 'react-router-dom';
function GRNDetailTable({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange,
  handleSort
}) {
  const originColumns = useMemo(
    () => [
      {
        accessor: 'wpo',
        Header: 'WPO'
      },
      {
        accessor: 'grn',
        Header: 'GRN'
      },
      {
        accessor: 'partNo',
        Header: 'PART No'
      },
      {
        accessor: 'description',
        Header: 'DESCRIPTION'
      },
      {
        accessor: 'received',
        Header: 'RECEIVED',
        Cell: rowData => {
          const date = moment(rowData.row.original.received);
          return date.isValid() ? date.format('DD/MM/YYYY') : 'Not received';
        }
      },
      {
        accessor: 'receivedQty',
        Header: 'Received Qty'
      },
      {
        accessor: 'receivedBy',
        Header: 'RECEIVED BY'
      }
    ],
    []
  );
  const { grnNo } = useParams();
  const [showImageModal, setShowImageModal] = useState(false);
  const [images, setImages] = useState([]);
  useEffect(() => {
    getGrnImages(grnNo).then(x => setImages(x.data ?? []));
  }, [grnNo]);
  return (
    <>
      {images.length > 0 && (
        <Row className="mb-2 g-2">
          <Col xs="auto">
            <Button
              variant="outline-primary"
              onClick={() => setShowImageModal(true)}
            >
              View Photo
            </Button>
          </Col>
        </Row>
      )}
      <ImageModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        images={images}
      />
      <PartialTable
        data={data}
        columns={originColumns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        beSortOption={{ canSort: true, handleSort: handleSort }}
        handleClickRow={() => {}}
      />
    </>
  );
}

GRNDetailTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  exportParam: PropTypes.object,
  colSort: PropTypes.object,
  handleSort: PropTypes.func,
  openGRNsModal: PropTypes.func
};

export default GRNDetailTable;
